<template>
    <Card>
        <div class="total-line">
            <template v-for="(item, index) in dataList" :key="index">
                <TotalBlock v-bind="item" :showDS1="false" :showDS2="false" :showDS3="false"></TotalBlock>
                <div class="split-line" v-if="index < dataList.length - 1"></div>
            </template>
        </div>
    </Card>
</template>
<script>
import TotalBlock from "../../../components/TotalBlock.vue";
export default {
    name: "TotalNumber1",
    components: { TotalBlock },
    data() {
        return {
            dataList: [],
        };
    },
    methods: {
        setData(data) {
            this.$ajax.post("/FlowData/GetEntityTotalNumber", data).then((result) => {
                let arr = result.Data;
                let list = [
                    {
                        title: "客流量（入园总数）",
                        data: {
                            d: arr[0].DataIn,
                        },
                        dec: 0,
                    },
                    {
                        title: "离园总数",
                        data: {
                            d: arr[0].DataOut,
                        },
                        dec: 2,
                    },
                    {
                        title: "在园总数",
                        data: {
                            d: Math.max(arr[0].DataIn - arr[0].DataOut, 0),
                        },
                        dec: 2,
                    },
                    {
                        title: "本周入园总数",
                        data: {
                            d: arr[1].DataIn,
                        },
                        dec: 2,
                    },
                    {
                        title: "本月入园总数",
                        data: {
                            d: arr[2].DataIn,
                        },
                        dec: 2,
                    },
                    {
                        title: "本年入园总数",
                        data: {
                            d: arr[3].DataIn,
                        },
                        dec: 2,
                    },
                ];
                this.dataList = list;
            });
        },
    },
};
</script>
